import { connect } from 'react-redux';

import TrekDay from '../../screens/Trek/TrekDay';

import {
  getSelectedTrekById,
  refreshDayData,
} from '../../redux/actions/selectedTrekActions';
import {
  toggleModal,
  openThemesModalAndSetSlideIndex,
} from '../../redux/actions/placesModalActions';
import { closeEditNotificationModal } from '../../redux/actions/alertModalActions';
import { editDayCard } from '../../redux/actions/patchToDay';
import {
  setServiceModalConfig,
  clearServiceModalConfig,
  changeServiceModalTheme,
  closeServicesModal,
} from '../../redux/actions/addToDayModalactions';
import { getDayData } from '../../redux/actions/dayActions';

const getNumberOfDays = itineraryObj => Object.keys(itineraryObj).length;

const mapStateToProps = (state, ownProps) => {
  const patchInfo = state.servicesModal.patchInfo;
  const day = patchInfo && state.schema.days.byId[patchInfo.dayNo];
  const route = day && day.routes[patchInfo.index];
  const routeLength = day && day.routes.length;
  const selectedTrekId = state.selectedTrek.trek && state.selectedTrek.trek.id;
  const selectedTrekRegion = state.selectedTrek.trek && state.selectedTrek.trek.region;
  const theme = state.servicesModal.theme;
  const data = state.schema.days.byId[ownProps.day];
  const noOfDays = state.selectedTrek.trek
    ? getNumberOfDays(state.selectedTrek.trek.itinerary)
    : 0;
  return {
    dataInfo: {
      routeInfo: state.servicesModal.routeInfo,
      patchInfo,
      route,
      routeLength,
      placeId: state.selectedPlace.id,
      selectedTrekId,
      selectedTrekRegion,
    },
    uiInfo: {
      theme,
      modalType: state.servicesModal.openPlacesModalFrom || 'none',
      cardsModalIsOpen: state.placesModal.modalIsOpen,
      serviceModalIsOpen: state.servicesModal.isModalOpen,
      dayEditModalIsOpen: state.alertModal.isModalOpen,
    },
    data,
    noOfDays,
    isLoggedIn: !!state.user.userId,
    trek: state.selectedTrek.trek,
  };
};

const mapDispatchToProps = dispatch => ({
  getSelectedTrekById: ({ id }) => dispatch(getSelectedTrekById(id)),
  refreshDayData: () => dispatch(refreshDayData()),
  toggleModal: ({ newModalState }) => dispatch(toggleModal(newModalState)),
  openSlider: ({ slideIndex, themeType }) =>
    dispatch(openThemesModalAndSetSlideIndex({ slideIndex, themeType })),
  toggleServicesModal: () => dispatch(closeServicesModal()),
  toggleDayEditModal: () => dispatch(closeEditNotificationModal()),
  addToDay: ({ cardData, theme }) =>
    dispatch(editDayCard({ cardData, theme, editType: 'add' })),
  setServiceModalConfig: ({ patchInfo, modalType }) =>
    dispatch(setServiceModalConfig({ patchInfo, modalType })),
  clearServiceModalConfig: () => dispatch(clearServiceModalConfig()),
  changeServiceModalTheme: ({ nextEntityType }) =>
    dispatch(changeServiceModalTheme({ theme: nextEntityType })),
  getDayData: ({ id, day }) => dispatch(getDayData(id, day)),
});

const TrekDayContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TrekDay);

export default TrekDayContainer;



// WEBPACK FOOTER //
// ./src/redux/containers/TrekDayContainer.js